export default __webpack_public_path__ + "static/silverXstag-4c58c46e4001c988384b5256432c9560.png";